import { render, staticRenderFns } from "./comentariosEnTienda .vue?vue&type=template&id=79ee772c&scoped=true"
import script from "./comentariosEnTienda .vue?vue&type=script&lang=js"
export * from "./comentariosEnTienda .vue?vue&type=script&lang=js"
import style0 from "./comentariosEnTienda .vue?vue&type=style&index=0&id=79ee772c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ee772c",
  null
  
)

export default component.exports